import React from 'react'

const Bakery = () => {
  return (
    <div>Bakery</div>
  )
}

export default Bakery